import { IconCheck } from "@/components/icons";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "@/theme/colors";

/**
 * Green-check feature list used by the package and pricing cards. Takes the
 * already-translated strings so it stays free of i18n concerns.
 */
export function Checklist({ items }: { items: readonly string[] }) {
  return (
    <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0, mb: 4 }}>
      {items.map((item) => (
        <Box
          key={item}
          component="li"
          sx={{ display: "flex", alignItems: "flex-start", gap: 1.25, mb: 1.5 }}
        >
          <IconCheck
            size={16}
            style={{
              color: colors.success,
              marginTop: 4,
              flexShrink: 0,
            }}
          />
          <Typography
            color="text.secondary"
            sx={{ fontSize: "0.95rem", lineHeight: 1.5 }}
          >
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
